module.exports = {
    "locales": ["nl"],
    "defaultLocale": "nl",
    "pages": {
        "*": ["common"]
    },
}